export default __webpack_public_path__ + "static/media/checkmark.fca09e59.svg";